/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Backup job type. `BACKUP_JOB_TYPE_UNSPECIFIED` is supported only in responses. 
*/
export enum BackupJobType {
  BackupJobTypeUnspecified = 'BACKUP_JOB_TYPE_UNSPECIFIED',
  AwsEc2Backup = 'AWS_EC2_BACKUP',
  AwsEbsVolumeBackup = 'AWS_EBS_VOLUME_BACKUP',
  AwsEc2SnapshotConversion = 'AWS_EC2_SNAPSHOT_CONVERSION',
  AwsRdsBackup = 'AWS_RDS_BACKUP',
  AwsS3Backup = 'AWS_S3_BACKUP',
  AwsFsxBackup = 'AWS_FSX_BACKUP',
  AwsEfsBackup = 'AWS_EFS_BACKUP',
  AwsRedshiftBackup = 'AWS_REDSHIFT_BACKUP',
  AwsDynamoDbBackup = 'AWS_DYNAMO_DB_BACKUP',
  AwsDynamoDbBackupFull = 'AWS_DYNAMO_DB_BACKUP_FULL',
  AwsEksNamespaceBackup = 'AWS_EKS_NAMESPACE_BACKUP',
  AzureStorageAccountBackup = 'AZURE_STORAGE_ACCOUNT_BACKUP',
  AzureVmBackup = 'AZURE_VM_BACKUP',
  AzureVmRestorePointConversion = 'AZURE_VM_RESTORE_POINT_CONVERSION',
  AzureSqlDatabaseBackup = 'AZURE_SQL_DATABASE_BACKUP',
  AzureSqlManagedInstanceBackup = 'AZURE_SQL_MANAGED_INSTANCE_BACKUP',
  AzureSqlVirtualMachineBackup = 'AZURE_SQL_VIRTUAL_MACHINE_BACKUP',
  AzureSqlVirtualMachineBackupFull = 'AZURE_SQL_VIRTUAL_MACHINE_BACKUP_FULL',
  AzurePostgresqlBackup = 'AZURE_POSTGRESQL_BACKUP',
  AzureMysqlBackup = 'AZURE_MYSQL_BACKUP',
  GcpComputeEngineInstanceBackup = 'GCP_COMPUTE_ENGINE_INSTANCE_BACKUP',
  GcpDiskBackup = 'GCP_DISK_BACKUP',
  GcpCloudStorageBackup = 'GCP_CLOUD_STORAGE_BACKUP',
  GcpCloudSqlBackup = 'GCP_CLOUD_SQL_BACKUP',
  GcpBigqueryBackup = 'GCP_BIGQUERY_BACKUP',
  AtlasMongodbClusterBackup = 'ATLAS_MONGODB_CLUSTER_BACKUP'
}
